export default __webpack_public_path__ + "static/media/remedyNav.d137faa5.png";